import Handlebars from 'handlebars';
import "oc-ui/dialogs/Dialogs.js";

import 'oc-commons/extensions/HandlebarsExtensions.js';

export function configurationTiles(element, filterConfig) {

    var showMaxEntries = parseInt(filterConfig.showmaxentries || Number.POSITIVE_INFINITY);

    var filterValues = _.map(_.filter(_.keys(filterConfig), function (key) {
        return key.startsWith('filter');
    }), function (key) {
        return filterConfig[key];
    });

    var select = _.map(filterValues, function (value, index) {
        var tags = value.split(/\s*,\s*/);
        return tags.map(function (tag, index) {
            return {
                'value': (index === 0) ? "" : tag,
                'label': tag
            };
        });
    });

    var serie = filterConfig['serie'];

    var queryString = 'table=Konfiguration&where.Inspiration=true';


    APP.wkfgBackendApi.loadMetadata(queryString).then(data => {
        showConfigurations(data.Konfiguration);
    });


    function showConfigurations(configurations) {

        configurations = _.sortBy(configurations, x => x.Sortierung);

        var templateConfig = {
            select: select,
            serie: serie,
            configuration: configurations,
        };

        var source = $('#configurationTilesTemplate').html();
        var template = Handlebars.compile(source);
        var box = template(templateConfig);

        element.html(box);

        $('.list-configurations-filter-selector').change(updateVisibleConfigurations);

        updateVisibleConfigurations();
    }

    function updateVisibleConfigurations() {
        var options = $('.list-configurations-filter-selector').map(function () {
            return $(this).val();
        });
        var index = 0;
        $(".list-configurations-filter-item[data-tags]").each(function () {
            var $this = $(this);
            var show = _.every(options, function (option) {
                var tags = $this.attr('data-tags').split(/\s*,\s*/);
                return option === "" || _.includes(tags, option);
            });
            if (show) {
                index++;
            }
            if (index >= showMaxEntries) {
                show = false;
            }
            if (show) {
                $this.show();
            } else {
                $this.hide();
            }
        });
    }

}
